<template>
  <v-card>
    <v-card-title>Vehicle Title Settings</v-card-title>
    <v-card-text>Enable/Disable Car Title Detail</v-card-text>
    <v-combobox
      :items="['conditions', 'year', 'make', 'model', 'trim']"
      chips
      removable-chips
      multiple
      clearable
      v-model="productSettings.vehicleTitleSettings.selectedVehicleTitles"
    ></v-combobox>

    <v-checkbox
      hide-details
      label="Display car VIN"
      v-model="productSettings.vehicleTitleSettings.displayCarVin"
    ></v-checkbox>
    <v-checkbox
      hide-details
      label="Display Stock#"
      v-model="productSettings.vehicleTitleSettings.displayCarStockNumber"
    ></v-checkbox>

    <!-- Vehicle Title Alignment Settings -->
    <v-divider class="my-4"></v-divider>
    <v-card-subtitle class="px-0 py-2">Vehicle Title Alignment</v-card-subtitle>
    <v-select
      label="Text alignment"
      v-model="productSettings.vehicleTitleSettings.align"
      :items="[
        { title: 'Left', value: 'left' },
        { title: 'Center', value: 'center' },
        { title: 'Right', value: 'right' },
      ]"
      variant="outlined"
      :prepend-inner-icon="
        getAlignmentIcon(productSettings.vehicleTitleSettings.align)
      "
      hide-details
    />
  </v-card>
</template>
<script setup lang="ts">
import { useProductSettingsStore } from '@/store/productSettings'
import { watch, onMounted } from 'vue'
import { getDefaultSettings } from '@/store/utils'

const productSettings = useProductSettingsStore()

const emit = defineEmits(['car-title-update'])

// Deduplicate and normalize selections to avoid duplicate chips (e.g., "conditions" twice)
watch(
  () => productSettings.vehicleTitleSettings.selectedVehicleTitles,
  newTitles => {
    const unique = Array.from(
      new Set((newTitles || []).map(t => String(t).toLowerCase().trim())),
    )
    if (!newTitles || unique.length !== newTitles.length) {
      productSettings.$patch(state => {
        state.vehicleTitleSettings.selectedVehicleTitles = unique
      })
    }
    emit('car-title-update', unique)
  },
  { deep: true },
)

onMounted(() => {
  if (
    !productSettings.vehicleTitleSettings.selectedVehicleTitles ||
    productSettings.vehicleTitleSettings.selectedVehicleTitles.length === 0
  ) {
    productSettings.$patch(state => {
      state.vehicleTitleSettings.selectedVehicleTitles =
        getDefaultSettings().vehicleTitle.selectedVehicleTitles ?? []
    })
  }
})

const getAlignmentIcon = (alignment: string) => {
  switch (alignment) {
    case 'left':
      return 'mdi-format-align-left'
    case 'center':
      return 'mdi-format-align-center'
    case 'right':
      return 'mdi-format-align-right'
    default:
      return 'mdi-format-align-left'
  }
}
</script>
